"use strict";
/**
 * @packageDocumentation
 * @module Logger.Constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = void 0;
var LoggerTypeBuilder_1 = require("../builder/LoggerTypeBuilder");
exports.types = {
    fatal: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("fatal")
        .withLevel("error")
        .withNewBadge(function (b) { return b.cross; })
        .withNewColor(function (c) { return c.red; })
        .get(),
    error: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("error")
        .withLevel("error")
        .withNewBadge(function (b) { return b.cross; })
        .withNewColor(function (c) { return c.red; })
        .get(),
    warn: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("warn")
        .withLevel("warn")
        .withNewBadge(function (b) { return b.warning; })
        .withNewColor(function (c) { return c.yellow; })
        .get(),
    success: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("success")
        .withLevel("info")
        .withNewBadge(function (b) { return b.tick; })
        .withNewColor(function (c) { return c.green; })
        .get(),
    wait: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("waiting")
        .withLevel("info")
        .withNewBadge(function (b) { return b.ellipsis; })
        .withNewColor(function (c) { return c.blue; })
        .get(),
    complete: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("complete")
        .withLevel("info")
        .withNewBadge(function (b) { return b.checkboxOn; })
        .withNewColor(function (c) { return c.cyan; })
        .get(),
    start: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("start")
        .withLevel("info")
        .withNewBadge(function (b) { return b.play; })
        .withNewColor(function (c) { return c.green; })
        .get(),
    stop: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("stop")
        .withLevel("info")
        .withNewBadge(function (b) { return b.squareSmallFilled; })
        .withNewColor(function (c) { return c.yellow; })
        .get(),
    watch: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("watching")
        .withLevel("info")
        .withNewBadge(function (b) { return b.ellipsis; })
        .withNewColor(function (c) { return c.yellow; })
        .get(),
    info: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("info")
        .withLevel("info")
        .withNewBadge(function (b) { return b.info; })
        .withNewColor(function (c) { return c.blue; })
        .get(),
    log: LoggerTypeBuilder_1.LoggerTypeBuilder.initial().get(),
    debug: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("debug")
        .withLevel("debug")
        .withNewBadge(function (b) { return b.circleCircle; })
        .withNewColor(function (c) { return c.gray; })
        .get(),
    silly: LoggerTypeBuilder_1.LoggerTypeBuilder.initial()
        .withLabel("silly")
        .withLevel("silly")
        .withNewBadge(function (b) { return b.circleCircle; })
        .withNewColor(function (c) { return c.gray; })
        .get(),
};
//# sourceMappingURL=types.js.map